// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

var $$Array = require("rescript/lib/js/array.js");
var $$String = require("rescript/lib/js/string.js");
var Belt_Array = require("rescript/lib/js/belt_Array.js");
var Caml_array = require("rescript/lib/js/caml_array.js");
var Belt_Option = require("rescript/lib/js/belt_Option.js");
var Caml_option = require("rescript/lib/js/caml_option.js");
var Webapi__Dom__Node = require("rescript-webapi/src/Webapi/Dom/Webapi__Dom__Node.bs.js");
var Webapi__Dom__Element = require("rescript-webapi/src/Webapi/Dom/Webapi__Dom__Element.bs.js");
var Webapi__Dom__Document = require("rescript-webapi/src/Webapi/Dom/Webapi__Dom__Document.bs.js");
var OptionUtils$SmartcutsMacros = require("../../bs-utils/src/OptionUtils.bs.js");

function maybeShadowRoot(el) {
  return Caml_option.nullable_to_opt(el.shadowRoot);
}

function isCustomWebComponentTagName(tagName) {
  return $$String.contains(tagName, /* '-' */45);
}

function isNodeNameDocumentFragment(nodeName) {
  return nodeName === "#document-fragment";
}

function isCustomWebComponent(element) {
  return $$String.contains(element.tagName, /* '-' */45);
}

function elementGet(v) {
  return v._0;
}

var ComposedPathNode = {
  elementGet: elementGet
};

function getComposedPath($$event) {
  var nativeComposedPath = $$event.composedPath();
  return Belt_Array.reduce(nativeComposedPath, [
                [],
                false
              ], (function (param, eventTarget) {
                  var transformedComposedPath = param[0];
                  if (eventTarget === window) {
                    return [
                            transformedComposedPath,
                            false
                          ];
                  }
                  var match = Webapi__Dom__Node.nodeType(eventTarget);
                  if (match >= 11) {
                    return [
                            transformedComposedPath,
                            false
                          ];
                  }
                  switch (match) {
                    case /* Element */0 :
                    case /* Text */2 :
                        break;
                    case /* Attribute */1 :
                    case /* CDATASection */3 :
                    case /* EntityReference */4 :
                    case /* Entity */5 :
                    case /* ProcessingInstruction */6 :
                    case /* Comment */7 :
                    case /* Document */8 :
                    case /* DocumentType */9 :
                        return [
                                transformedComposedPath,
                                false
                              ];
                    case /* DocumentFragment */10 :
                        return [
                                transformedComposedPath,
                                true
                              ];
                    
                  }
                  var nextTransformedComposedPath = $$Array.append(transformedComposedPath, [param[1] ? ({
                              TAG: /* ShadowRoot */0,
                              _0: eventTarget
                            }) : ({
                              TAG: /* Element */1,
                              _0: eventTarget
                            })]);
                  return [
                          nextTransformedComposedPath,
                          false
                        ];
                }))[0];
}

function getTargetFromEvent($$event) {
  var immediateTargetElement = $$event.target;
  if (!$$String.contains(immediateTargetElement.tagName, /* '-' */45)) {
    return immediateTargetElement;
  }
  var composedPath = getComposedPath($$event);
  return Caml_array.get(composedPath, 0)._0;
}

function getActiveElementForDocument(param) {
  var arg = Webapi__Dom__Document.asHtmlDocument(document);
  return Belt_Option.map((function (param) {
                  return OptionUtils$SmartcutsMacros.andThen(param, arg);
                })(function (prim) {
                  return Caml_option.nullable_to_opt(prim.activeElement);
                }), (function (activeElement) {
                if (!$$String.contains(activeElement.tagName, /* '-' */45)) {
                  return activeElement;
                }
                console.warn("activeElement", activeElement);
                var arg = Belt_Option.flatMap(Caml_option.nullable_to_opt(activeElement.shadowRoot), (function (prim) {
                        return prim.activeElement;
                      }));
                return OptionUtils$SmartcutsMacros.withDefault(activeElement, arg);
              }));
}

function getActiveHtmlElementForDocument(param) {
  return OptionUtils$SmartcutsMacros.andThen(Webapi__Dom__Element.asHtmlElement, getActiveElementForDocument(undefined));
}

exports.maybeShadowRoot = maybeShadowRoot;
exports.isCustomWebComponentTagName = isCustomWebComponentTagName;
exports.isNodeNameDocumentFragment = isNodeNameDocumentFragment;
exports.isCustomWebComponent = isCustomWebComponent;
exports.ComposedPathNode = ComposedPathNode;
exports.getComposedPath = getComposedPath;
exports.getTargetFromEvent = getTargetFromEvent;
exports.getActiveElementForDocument = getActiveElementForDocument;
exports.getActiveHtmlElementForDocument = getActiveHtmlElementForDocument;
/* Webapi__Dom__Node Not a pure module */
